import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo-page/labels';

Component('tr-todo-page-labels', {
  mixins: [eventListenerMixin],

  properties: {
    empty: {
      type: Boolean,
      default: true,
    },

    editUrl: String,
  },

  connected() {
    this.listenTo(this, 'tr-multiple-select-field:change', this.handleLabelsChange.bind(this));
  },

  handleLabelsChange(event) {
    event.stopPropagation();
    const labels = event.detail;
    const data = labels.length ? { label_ids: labels } : { 'label_ids[]': '' };

    this.empty = !labels.length;

    this.update(data)
      .then((todo) => {
        this.namespacedTrigger('labelsChange', {
          detail: { todo },
          bubbles: true,
        });
      });
  },

  update(data) {
    if (this.editUrl) {
      return $.ajax({
        url: this.editUrl,
        type: 'patch',
        dataType: 'json',
        data: {
          todos_management: data,
        },
      });
    }

    return new Promise(resolve => resolve(data));
  },

  disconnected() {
    this.stopListening();
  },
});
